import { render } from "./ContractsList.vue?vue&type=template&id=e1f5a01c"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__